import React from "react";
import Truncate from "@/containers/project-screen/Truncate";
import Icon from "@/components/icon";

const CollapsableText = ({
  children,
  numberOfLines,
  className,
  moreClassName,
  moreText,
}) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={className}>
      <Truncate
        width={0}
        lines={!isExpanded ? numberOfLines : 0}
        ellipsis={
          <span>
            <span className={moreClassName} onClick={toggleExpand}>
              {moreText || "عرض المزيد"}
              <Icon name="leftArrow-searches" width={12} height={12} />
            </span>
          </span>
        }
      >
        {children}
      </Truncate>
    </div>
  );
};

export default CollapsableText;
